<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-3">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-card>
      <b-row class="mb-2 px-2">

        <b-col
          cols="12"
          md="9"
          class="px-1"
        >
          <b-form-group>
            <label
              for="filter_search"
            >
              <strong>
                Search
              </strong>
            </label>
            <b-input
              id="filter_search"
              v-model="tableDepartments.filter"
              type="text"
              placeholder="search here"
              debounce="1000"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="3"
          class="px-1"
        >
          <b-form-group>
            <label
              for="filter_unit"
            >
              <strong>
                Unit
              </strong>
            </label>
            <b-select
              id="filter_unit"
              v-model="filter.unit"
              :options="filterUnits"
              :disabled="state.busy"
              @change="onRefrehsTableDepartments"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="px-1"
        >
          <b-button
            type="button"
            variant="primary"
            @click="onShowAddFormDepartment"
          >
            Add Department
          </b-button>
        </b-col>
      </b-row>

      <b-table
        ref="tableDepartments"
        hover
        responsive
        show-empty
        class="mt-2"
        :per-page="tableDepartments.perPage"
        :current-page="tableDepartments.currentPage"
        :items="myProvider"
        :fields="tableDepartments.fields"
        :sort-by.sync="tableDepartments.sortBy"
        :sort-desc.sync="tableDepartments.sortDesc"
        :sort-direction="tableDepartments.sortDirection"
        :filter="tableDepartments.filter"
        :filter-included-fields="tableDepartments.filterOn"
      >
        <template #cell(index)="row">
          {{ tableDepartments.currentPage * tableDepartments.perPage - tableDepartments.perPage + (row.index + 1) }}
        </template>

        <template #cell(active)="row">
          {{ row.item.active == 1 ? "Yes" : "No" }}
        </template>

        <template #cell(department_name)="row">
          <div class="text-nowrap">
            <strong>{{ row.value }}</strong>
          </div>
        </template>

        <template #cell()="row">
          <div class="text-nowrap">
            {{ row.value }}
          </div>
        </template>

        <template #cell(action)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditFormDepartment(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableDepartments.perPage"
              :options="tableDepartments.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableDepartments.currentPage"
            :total-rows="tableDepartments.totalRows"
            :per-page="tableDepartments.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-department"
      scrollable
      no-close-on-backdrop
      :title="modalTitle"
      aria-hidden="false"
      @ok="onValidateFormDepartment"
    >
      <ValidationObserver
        ref="formDepartment"
      >
        <form
          novalidate
          @submit.prevent="true"
        >
          <ValidationProvider
            #default="{ errors }"
            name="unit"
            vid="unit"
            rules="required"
          >
            <b-form-group>
              <label for="unit">
                <strong>
                  Unit
                </strong>
              </label>
              <b-form-select
                id="unit"
                v-model="department.unit"
                :options="list.units"
                :state="errors.length > 0 ? false : null"
                :disabled="state.busy"
              >
                <template #first>
                  <b-form-select-option
                    :value="null"
                    disabled
                  >
                    -- select unit --
                  </b-form-select-option>
                </template>
              </b-form-select>
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider
            #default="{ errors }"
            name="department name"
            vid="department_name"
            rules="required|max:100"
          >
            <b-form-group>
              <label
                for="department_name"
              >
                <strong>
                  Department
                </strong>
              </label>
              <b-input
                id="department_name"
                v-model="department.department_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter department name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="department.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Is Active?
            </b-form-checkbox>
          </div>
        </form>
      </ValidationObserver>

      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? "Update Record" : "Save Record" }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>
    </b-modal>

  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import {
  AdminDepartmentService,
  SharedListService
} from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminDepartments',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Departments'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      filter: {
        unit: 'All'
      },
      list: {
        units: []
      },
      department: {
        id: null,
        department_code: null,
        department_name: null,
        active: 0,
        unit: null
      },
      tableDepartments: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        fields: [
          { key: 'index', class: 'text-center' },
          { key: 'action', class: 'text-center' },
          { key: 'unit.unit_name', label: 'unit' },
          { key: 'department_name', label: 'department', sortable: true },
          { key: 'active', class: 'text-center' },
          { key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalTitle () {
      return this.state.editing ? 'Edit Department' : 'Add Department'
    },

    filterUnits () {
      return [{ text: 'All', value: 'All' }].concat(this.list.units)
    }
  },

  mounted () {
    core.index()
    this.getUnits()
  },

  methods: {
    async myProvider (ctx) {
      return await AdminDepartmentService.get(
        this.objectToUrl({
          page: ctx.currentPage,
          per_page: ctx.perPage,
          sort: ctx.sortBy,
          sort_desc: ctx.sortDesc,
          filter_text: ctx.filter,
          filter_unit: this.filter.unit
        })
      ).then(({ data }) => {
        this.tableDepartments.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        return []
      })
    },

    onRefrehsTableDepartments () {
      this.$refs.tableDepartments.refresh()
    },

    async getUnits () {
      SharedListService.getUnits().then(({ data }) => {
        this.list.units = data.map(({ id, unit_name }) => ({
          text: unit_name,
          value: id
        }))
      })
    },

    onShowAddFormDepartment () {
      this.state.editing = false
      this.department.id = 0
      this.department.unit = null
      this.department.department_name = null
      this.department.active = 1
      this.$bvModal.show('modal-department')
    },

    onShowEditFormDepartment (department) {
      this.state.editing = true
      this.department.id = department.id
      this.department.unit = department.unit_id
      this.department.department_name = department.department_name
      this.department.active = department.active
      this.$bvModal.show('modal-department')
    },

    async onValidateFormDepartment (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.formDepartment.validate().then(async success => {
        if (success) {
          let text = 'Do you really want to create department?'

          if (this.state.editing) {
            text = 'Do you really want to save changes?'
          }

          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: text,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.state.busy = true
              if (this.state.editing) {
                return this.onPostFormDepartment()
              } else {
                return this.onPutFormDepartment()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk(
            'Oops! There were problem with your inputs.', {
              title: 'Validation Error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              centered: true
            }
          )
        }
      })
    },

    async onPutFormDepartment () {
      return new Promise(resolve => {
        AdminDepartmentService.post(this.department).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-department')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.tableDepartments.refresh()
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formDepartment.setErrors(error.message)
          resolve(error)
        })
      })
    },

    async onPostFormDepartment () {
      return new Promise(resolve => {
        AdminDepartmentService.put(this.department).then(({ data }) => {
          this.$bvModal.hide('modal-department')
          this.state.busy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.tableDepartments.localItems, { id: data.department.id })
            row.unit = data.department.unit
            row.unit_id = data.department.unit_id
            row.department_name = data.department.department_name
            row.active = data.department.active
            row.updated_at = data.department.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formDepartment.setErrors(error.message)
          resolve(error)
        })
      })
    }
  }
}
</script>
